import { InboxesParams, service } from "@theprelude/core";
import { useInfiniteODataQuery } from "./use-infinite-odata-query";

export const useInfiniteInboxes = (params: InboxesParams) => {
  return useInfiniteODataQuery({
    key: "inboxes",
    params,
    fetch: (authConfig, params) => service(authConfig).scm.inboxes(params),
  });
};
